<template>
    <footer class="footer">
        <div class="footer-content">
            <!-- Columna 1: Sobre Nosotros -->
            <div class="footer-column">
                <h3>{{ config && config.site_name || '' }}</h3>
                <p>{{ config && config.site_description || '.' }}</p>
                <!-- {{socialNetworks}} -->
                <!-- Redes Sociales -->
                <div class="footer-social" v-if="socialNetworks && socialNetworks.length">
                    <a 
                        v-for="social in socialNetworks" 
                        :key="social.id"
                        :href="social.url" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        class="social-link"
                        :title="social.name"
                    >
                        <i :class="social.icon"></i>
                    </a>
                </div>
            </div>
            
            <!-- Columna 2: Enlaces Rápidos -->
            <div class="footer-column">
                <h3>Enlaces Rápidos</h3>
                <ul class="footer-links">
                    <li><router-link to="/">Inicio</router-link></li>
                    <li><router-link to="/blog">Blog</router-link></li>
                    <li><router-link to="/videos">Videos</router-link></li>
                    <li><router-link to="/drivers-descargas">Drivers</router-link></li>
                    <li><router-link to="/soporte-tecnico">Soporte</router-link></li>
                    <li><router-link to="/contacto">Contacto</router-link></li>
                </ul>
            </div>
            
            <!-- Columna 3: Contáctanos -->
            <div class="footer-column">
                <h3>Contáctanos</h3>
                
                <div class="footer-contact" v-if="config">
                    <!-- Dirección -->
                    <div class="contact-item" v-if="config.address">
                        <i class="fas fa-map-marker-alt"></i>
                        <span>{{ config.address }}<span v-if="config.district">, {{ config.district }}</span><span v-if="config.city">, {{ config.city }}</span></span>
                    </div>
                    
                    <!-- Emails -->
                    <div class="contact-item" v-if="emails && emails.length">
                        <i class="fas fa-envelope"></i>
                        <div>
                            <a 
                                v-for="email in emails.slice(0, 2)" 
                                :key="email.id"
                                :href="`mailto:${email.email}`"
                            >
                                {{ email.email }}
                            </a>
                        </div>
                    </div>
                    
                    <!-- Teléfonos -->
                    <div class="contact-item" v-if="phones && phones.length">
                        <i class="fas fa-phone"></i>
                        <div>
                            <a 
                                v-for="phone in phones.slice(0, 2)" 
                                :key="phone.id"
                                :href="`tel:+${phone.phone}`"
                            >
                                +{{ phone.phone }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="footer-bottom">
            <p>
                &copy; {{ new Date().getFullYear() }} 
                {{ config && config.site_name || 'POS Solutions' }}. 
                Todos los derechos reservados.
            </p>
        </div>
    </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Footer',
    computed: {
        ...mapState(['config']),
        ...mapGetters(['emails', 'phones', 'socialNetworks'])
    },
    mounted() {
        console.log('Footer config:', this.config);
        console.log('Emails:', this.emails);
        console.log('Phones:', this.phones);
        console.log('Social Networks:', this.socialNetworks);
    }
};
</script>

<style scoped>
.footer {
    background: var(--primary-dark);
    border-top: 1px solid rgba(212, 175, 55, 0.2);
    padding: 80px 2rem 30px;
}

.footer-content {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
    margin-bottom: 3rem;
}

.footer-column h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: var(--accent-gold);
}

.footer-column p {
    color: var(--text-gray);
    line-height: 1.8;
    margin-bottom: 1.5rem;
}

.footer-social {
    display: flex;
    gap: 1rem;
}

.social-link {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: var(--card-bg);
    border: 1px solid rgba(212, 175, 55, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-light);
    transition: all 0.3s ease;
    font-size: 1.2rem;
}

.social-link:hover {
    background: var(--accent-gold);
    color: var(--primary-dark);
    transform: translateY(-5px);
    border-color: var(--accent-gold);
}

.footer-links {
    list-style: none;
}

.footer-links li {
    margin-bottom: 0.8rem;
}

.footer-links a {
    color: var(--text-gray);
    text-decoration: none;
    transition: all 0.3s ease;
    display: inline-block;
}

.footer-links a:hover {
    color: var(--accent-gold);
    padding-left: 0.5rem;
}

.footer-contact {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.contact-item {
    display: flex;
    gap: 1rem;
    color: var(--text-gray);
    align-items: flex-start;
}

.contact-item i {
    color: var(--accent-gold);
    font-size: 1.2rem;
    width: 20px;
    margin-top: 2px;
}

.contact-item div {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.contact-item a {
    color: var(--text-gray);
    text-decoration: none;
    transition: color 0.3s ease;
}

.contact-item a:hover {
    color: var(--accent-gold);
}

.contact-item span {
    line-height: 1.6;
}

.footer-bottom {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 2rem;
    border-top: 1px solid rgba(212, 175, 55, 0.1);
    text-align: center;
    color: var(--text-gray);
}

/* RESPONSIVE */
@media (max-width: 1024px) {
    .footer-content {
        grid-template-columns: repeat(2, 1fr);
        gap: 3rem;
    }
    
    .footer-column:last-child {
        grid-column: 1 / -1;
    }
}

@media (max-width: 768px) {
    .footer {
        padding: 60px 1rem 20px;
    }
    
    .footer-content {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
    
    .footer-column:last-child {
        grid-column: auto;
    }
    
    .footer-column h3 {
        font-size: 1.3rem;
    }
}
</style>